import Api from "../../../lib/api";

export const ACTION_TYPE_FETCH_YEAR_SUMMARY_START =
  "ACTION_TYPE_FETCH_YEAR_SUMMARY_START";
export const ACTION_TYPE_FETCH_YEAR_SUMMARY_END =
  "ACTION_TYPE_FETCH_YEAR_SUMMARY_END";
export const ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR =
  "ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR";

const fetchYearSummaryStart = () => ({
  type: ACTION_TYPE_FETCH_YEAR_SUMMARY_START,
});

const fetchYearSummaryEnd = (data) => ({
  type: ACTION_TYPE_FETCH_YEAR_SUMMARY_END,
  data,
});

const fetchYearSummaryError = (error) => ({
  type: ACTION_TYPE_FETCH_YEAR_SUMMARY_ERROR,
  error,
});

export const fetchYearSummary = (year) => {
  return (dispatch) => {
    dispatch(fetchYearSummaryStart());
    return Api.get(Api.API_HOME_SUMMARY_DATA(year))
      .then((response) => {
        dispatch(fetchYearSummaryEnd(response.data));
      })
      .catch((error) => {
        dispatch(fetchYearSummaryError(error));
      });
  };
};



// WEBPACK FOOTER //
// ./routes/home/actions/index.js